import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";

const InvoicingModalCard = ({
  isInvoicingModalOpen,
  setIsInvoicingModalOpen,
  person,
  onTrack,
}) => {
  const regularAddress = [person.address, person.city].join(", ");
  const invoicingAddress = person.billingAddress || regularAddress;
  const closeModal = () => {
    onTrack?.("invoicing_modal_close", {
      source: "public_card",
    });
    setIsInvoicingModalOpen(false);
  };

  return (
    <Transition.Root show={isInvoicingModalOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-[#1b8395] bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative bg-white rounded-2xl px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-sm sm:w-full sm:p-6">
                <h5 className="font-bold leading-tight text-xl my-5 text-[#1b8395] text-center">
                  Dati di Fatturazione
                </h5>

                <div className="grid grid-cols-1 gap-4">
                  {person.billingCompanyName && (
                    <>
                      <div className="bg-[#f2f4f7]/50 p-3 rounded-lg">
                        <div className="text-sm text-gray-600 mb-1">Ragione Sociale</div>
                        <div className="font-medium text-[#1b8395]">{person.billingCompanyName}</div>
                      </div>
                    </>
                  )}
                  {invoicingAddress && (
                    <>
                      <div className="bg-[#f2f4f7]/50 p-3 rounded-lg">
                        <div className="text-sm text-gray-600 mb-1">Indirizzo</div>
                        <div className="font-medium text-[#1b8395]">{invoicingAddress}</div>
                      </div>
                    </>
                  )}
                  {person.vat && (
                    <>
                      <div className="bg-[#f2f4f7]/50 p-3 rounded-lg">
                        <div className="text-sm text-gray-600 mb-1">Partita IVA</div>
                        <div className="font-medium text-[#1b8395]">{person.vat}</div>
                      </div>
                    </>
                  )}
                  {person.pec && (
                    <>
                      <div className="bg-[#f2f4f7]/50 p-3 rounded-lg">
                        <div className="text-sm text-gray-600 mb-1">PEC</div>
                        <div className="font-medium text-[#1b8395]">{person.pec}</div>
                      </div>
                    </>
                  )}
                  {person.electronicInvoicingId && (
                    <>
                      <div className="bg-[#f2f4f7]/50 p-3 rounded-lg">
                        <div className="text-sm text-gray-600 mb-1">Codice Destinatario</div>
                        <div className="font-medium text-[#1b8395]">{person.electronicInvoicingId}</div>
                      </div>
                    </>
                  )}
                </div>
                <div className="mt-5">
                  <button
                    type="button"
                    className="inline-flex justify-center w-full rounded-xl border border-transparent px-4 py-3 bg-[#20acad] text-white font-semibold hover:bg-[#1b8395] focus:outline-none transition-colors"
                    onClick={closeModal}
                  >
                    Torna alla card
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default InvoicingModalCard;
